import ListItem from "../../../components/ListItem";
import React, { useState } from "react";
import { $ } from "../../../../../vendor";

const OrderListItem = (props) => {
  const currentUrl = new URL(window.location.href);
  const searchParams = currentUrl.searchParams;
  const toggleElement = (ev, key) => {
    $("#reservation-panel-" + key).toggleClass("active");
    $("#row-" + key).toggleClass("toggled");
    searchParams.set("item", key);
    const newRelativePathQuery = window.location.pathname + "?" + searchParams.toString();
    history.pushState(null, "", newRelativePathQuery);
  };

  return (
    <>
      <ListItem
        key={props.key}
        listStyle={props.listStyle}
        id={props.id}
        overwriteClasses={props.overwriteClasses}
        elements={props.elements}
        menu={props.menu}
        app_user_role={props.app_user_role}
        extra={true}
        refLink={props.refLink}
        length={props.length}
        toggleElement={toggleElement}
        orderReservation={true}
        order={props.order}
        locations={props.locations}
        _exchangeLabel={props._exchangeLabel}
        setCheckout={props.setCheckout}
        checkout={props.checkout}
        setCheckoutReservation={props.setCheckoutReservation}
        setCheckoutCheckin={props.setCheckoutCheckin}
        dispatch={props.dispatch}
        setId={true}
        setFilter={props.setFilter}
        filter={props.filter}
        setNKey={props.setNKey}
        sort={props.sort}
        setSort={props.setSort}
        _key={props._key}
        itemPending={props.itemPending}
        showNotification={props.showNotification}
      />
    </>
  );
};

export default OrderListItem;
